import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar"
import FontAwesome from "react-fontawesome";
import UserHandler from "js/utilities/user-handler";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import { ZOOM_ICON } from "js/config.jsx";

export default React.createClass({
  displayName: "new-release-info",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var scrollToElement = initDeepLinkData(this.props);
    return {
        scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container quick-guides-pages">

              <section id="Introduction">
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="technical-support">New Release Info</h2>
                </div>
                <p>FaceTec releases updates to FaceTec SDK frequently that improve security, user experience, algorithmic accuracy, performance, compatibility, and add new features and customizations.  Find out more about these updates below!</p>
                <hr/>
              </section>

              <section>
                <div className="panel-holder">
                  <Link to="/release-notes" className="panel-button">
                    <FontAwesome name="list" className="fontawesome-icon" />
                    <h5 className="big">Release Notes</h5>
                  </Link>
                  <Link to="/updating" className="panel-button">
                    <FontAwesome name="angle-double-up" className="fontawesome-icon" />
                    <h5 className="big">Keeping Up-to-Date</h5>
                  </Link>
                  <Link to="/release-practices" className="panel-button">
                    <FontAwesome name="code" className="fontawesome-icon" />
                    <h5 className="big">Release Practices</h5>
                  </Link>
                </div>
              </section>

              <SDKSidebar menuType="main" title="New Release Info"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/new-release-info.jsx